<template>
  <div :class="[textAlign, 'relative']">
    <span
      aria-hidden="true"
      :style="{
        color: textShadowColor,
      }"
      :class="[
        'absolute inset-0 z-0 h-full w-full',
        topPositioning,
        leftPositioning,
        font,
        textSize,
        textOutlineClass,
      ]"
    >
      {{ props.text }}
    </span>
    <span
      :style="{
        color: textColor,
      }"
      :class="['relative z-0', font, textSize, textOutlineClass]"
    >
      {{ props.text }}
    </span>
  </div>
</template>

<script lang="ts" setup>
interface StylizedCurvyTextProps {
  textAlign?: string;
  text: string;
  font?: string;
  textSize?: string;
  textColor?: string;
  topPositioning?: string;
  leftPositioning?: string;
  textShadowColor?: string;
  textOutlineClass?: string;
}

const props = withDefaults(defineProps<StylizedCurvyTextProps>(), {
  textAlign: "text-start",
  text: "",
  topPositioning: "top-[0.090em]",
  leftPositioning: "left-[0.03em]",
  font: "font-KelsiFill",
  textSize: "text-4xl sm:text-[76px] whitespace-nowrap leading-tight",
  textColor: "#96F14F",
  textShadowColor: "#E7622C",
  textOutlineClass: "text-outline-mobile lg:text-outline",
});
</script>
